import { createContext, useContext, type ReactNode } from 'react'
import { Lines, type LinesInterface } from './Lines'

const QuoteLinesContext = createContext<LinesInterface | null>(null)

export function QuoteLinesProvider({ children }: { children: ReactNode }) {
  const lines = Lines()
  return <QuoteLinesContext.Provider value={lines}>{children}</QuoteLinesContext.Provider>
}

export function useQuoteLines(): LinesInterface {
  const lines = useContext(QuoteLinesContext)
  if (!lines) {
    throw new Error('useQuoteLines must be used within QuoteLinesProvider')
  }
  return lines
}
